import i18n from 'i18next';
import backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
const publicBasePath = process.env.REACT_APP_PUBLIC_BASE_NAME;

i18n
  .use(initReactI18next)
  .use(backend)
  .init({
    lng: 'hr',
    fallbackLng: 'en',
    defaultNS: 'dictionary',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: `${publicBasePath || ''}/locales/{{lng}}/{{ns}}.json`,
    },
  });

export default i18n;
